import * as Yup from "yup";

/**
 * Form validation schema for /auth/forgot-password
 */
export const ForgotPasswordValidationSchema = Yup.object().shape({
	email: Yup.string().email("Email is not valid").required("Email is required"),
});
